export default () => ({
    checked: false,
    init() {
        Alpine.nextTick().then(() => {
            // noinspection JSUnresolvedReference
            this.checked = parseInt(this.$root.getAttribute('data-checked')) === 1;
        })
    }
});
